import React, { Fragment, useEffect, useState } from 'react';
import { Segment, Header, Menu, Breadcrumb } from 'semantic-ui-react';
import Clipboard from 'react-clipboard.js';
import Timezone from '../Timezone.jsx';
import EventEmitter from '../../util/eventEmitter.js';

export default function DockerImagesTextbox(props) {
  const [images, setImages] = useState(props.images);
  const [lastChecked, setLastChecked] = useState(props.date);
  const [error, setError] = useState(props.error);

  const imagesUpdateHandler = (data) => {
    setImages(data.images);
    setLastChecked(data.last_checked);
    setError(data.error);

    // Tells timezone component to update itself
    EventEmitter.emit(
      '/timezone_' + props.hostname + '_date_update',
      data.last_checked,
    );
  };

  const noImagesFound = () => {
    return <pre> No images found for {props.hostname}.</pre>;
  };

  const errorRetrieving = () => {
    return (
      <pre>
        Unable to retrieve docker images.
        <a href={props.logs}> More Details.</a>
      </pre>
    );
  };

  const renderDockerImages = () => {
    return (
      <table id='docker-images-list'>
        <thead>
          <tr>
            <th>REPOSITORY</th>
            <th>TAG</th>
            <th>IMAGE ID</th>
            <th>CREATED</th>
            <th>SIZE</th>
          </tr>
        </thead>
        <tbody>
          {images.map((img) => (
            <tr key={img.ID}>
              <td>{img.Repository}</td>
              <td>{img.Tag}</td>
              <td>{img.ID}</td>
              <td>{img.CreatedSince}</td>
              <td>{img.Size}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const dockerImages = () => {
    if (typeof error !== 'undefined') {
      return errorRetrieving();
    } else if (typeof images === 'undefined' || images.length === 0) {
      return noImagesFound();
    } else {
      return renderDockerImages();
    }
  };

  const clipboardContent = () => {
    var content;

    if (images.length === 0) {
      return '';
    }

    content = images.map(
      (img) =>
        img.Repository +
        '\t' +
        img.Tag +
        '\t' +
        img.ID +
        '\t' +
        img.CreatedSince +
        '\t' +
        img.Size,
    );

    content[0] = 'REPOSITORY\tTAG\tIMAGE\tID\tCREATED\tSIZE';
    return content.join('\n');
  };

  useEffect(() => {
    Messenger.on(props.updateChannel, imagesUpdateHandler);

    return () => {
      Messenger.unsubscribe(props.updateChannel);
    };
  });

  return (
    <Fragment>
      <Menu
        fluid
        secondary
      >
        <Menu.Item
          fitted
          header
        >
          <Header
            as='h3'
            className='last-checked-container'
          >
            Docker Images for {props.hostname}
            <If condition={lastChecked !== ''}>
              <Header.Subheader>
                Last Checked:{' '}
                <Timezone
                  date={lastChecked}
                  format={'dddd, MMMM Do YYYY, h:mm:ss a z'}
                  identifier={props.hostname}
                  zones={['user']}
                />
              </Header.Subheader>
            </If>
          </Header>
        </Menu.Item>
      </Menu>

      <div className='docker-images-helpers'>
        <Breadcrumb size='small'>
          <Breadcrumb.Section
            content='Nodes'
            href={props.list}
          />
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section
            content={props.hostname}
            href={props.details}
          />
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section content='Docker Images' />
        </Breadcrumb>

        <Clipboard
          className='copy-images'
          component='div'
          data-clipboard-text={clipboardContent()}
          position='right'
        >
          <button className='ui labeled icon button copy'>
            <i className='copy icon'></i>
            Copy to Clipboard
          </button>
        </Clipboard>
      </div>

      <Segment className='docker-images-output'>{dockerImages()}</Segment>
    </Fragment>
  );
}
